import { Moment } from 'moment';
import * as React from 'react';
import Person from 'src/entities/Person';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';
import ResultPageCardComponent from '../../commons/result-page/ResultPageCard.Component';
import MyAccountHeaderComponent from '../partials/MyAccountHeader.component';
import EditFormsPhysicalPersonUpdate from './forms/EditFormsPhysicalPersonUpdate';
import './PhysicalPersonUpdate.css';

interface Props {
  physicalPerson: PhysicalPerson;
  formData: PhysicalPersonData;
  profilePicture?: File;
  idFront?: File;
  idBack?: File;
  error: boolean;
  errorMessage: {};
  success: boolean;
  sectors: SectorOfInterest[];
  defaultProfile?: Person;
  checkboxState: boolean;
  canChangeCheckbox: boolean;
  handleChange(key: string): (value: string | File | boolean | Moment) => void;
  handleChangeSpouse(key: string): (value: string | File | boolean | Moment) => void;
  handleSubmit(): void;
  handleChangeDefaultProfile(): void;
  handleChangeCheckbox(): void;
  handlePublicProfileCheckbox(): void;
}

class PhysicalPersonUpdateComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <section>
        <div className="container">
          <MyAccountHeaderComponent pageTitle="Mi cuenta"/>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-sm-12">
              <div className="">
                {!this.props.success ?
                  <EditFormsPhysicalPersonUpdate
                    physicalPerson={this.props.physicalPerson}
                    formData={this.props.formData}
                    handleChange={this.props.handleChange}
                    handleChangeSpouse={this.props.handleChangeSpouse}
                    handleSubmit={this.props.handleSubmit}
                    error={this.props.error}
                    errorMessage={this.props.errorMessage}
                    sectors={this.props.sectors}
                    profilePicture={this.props.profilePicture}
                    idFront={this.props.idFront}
                    idBack={this.props.idBack}
                    defaultProfile={this.props.defaultProfile}
                    handleChangeDefaultProfile={this.props.handleChangeDefaultProfile}
                    checkboxState={this.props.checkboxState}
                    canChangeCheckbox={this.props.canChangeCheckbox}
                    handleChangeCheckbox={this.props.handleChangeCheckbox}
                    handlePublicProfileCheckbox={this.props.handlePublicProfileCheckbox}
                  /> :
                  <ResultPageCardComponent
                    title="Tu perfil de inversor se ha actualizado correctamente"
                    message="Ahora te resultará más cómodo invertir en las mejores oportunidades de inversión"
                    success={true}
                  />
                }
              </div>
            </div>
          </div>
          <div className="gap-20"/>
        </div>
      </section>
    );
  }

}

export default PhysicalPersonUpdateComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/PhysicalPersonUpdate.component.tsx